import { DEMO_TODAY } from '../fixtures';
import type { DemoAction } from './actions';

/**
 * Act 1, the Advisor Portal: what was written to Veritant from Help (step 6). It held two slices
 * more: the email-change request, until SR-416 made the change live on the Account page, and team
 * registration (step 3), a run over the onboarding study's gating tree, live since SR-213's teams
 * block — `/registration` walks survey-api's own questions. Nothing of either is kept here.
 */

export interface IHelpMessage {
  id: string;
  topic: string;
  message: string;
  reference: string;
  sentAt: string;
}

export interface IAct1State {
  helpMessages: IHelpMessage[];
}

export function initialAct1(): IAct1State {
  return { helpMessages: [] };
}

export function act1Reducer(state: IAct1State, action: DemoAction): IAct1State {
  switch (action.type) {
    case 'help/send':
      return {
        ...state,
        helpMessages: [
          ...state.helpMessages,
          {
            id: `m-${state.helpMessages.length + 1}`,
            topic: action.topic,
            message: action.message,
            reference: action.reference,
            sentAt: DEMO_TODAY
          }
        ]
      };
    default:
      return state;
  }
}
